module.exports = __webpack_public_path__ + "img/img-14.7e4a8f0a.png";